import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { PhameeService } from 'src/app/services/phamee.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MouseEvent } from '@agm/core';

@Component({
  selector: 'smart-manage-thing-map',
  templateUrl: './manage-thing-map.component.html',
  styleUrls: ['./manage-thing-map.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingMapComponent implements OnInit {
  AllPlot: any[] = [];
  polygons: any[] = [];
  markers: marker[] = [];

  lat: number = 13.764913;
  lng: number = 100.538283;
  zoom: number = 18;
  loadFarm: boolean = false;
  loadMap: boolean = false;
  loadPolygon: boolean = false;

  @Input()
  farm_id: string;

  @Input()
  plot_id: string;

  @Input()
  map_point: any;

  @Output() done = new EventEmitter<any>();
  @ViewChild("closeModal") private closeModal: ElementRef;
  constructor(
    private phameeService: PhameeService,
    private spinner: NgxSpinnerService,

    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if(this.farm_id){

      this.getPlots(this.farm_id);

      if(this.map_point.lat && this.map_point.lon){

        this.markers = [];
        this.markers.push({
          lat: this.map_point.lat,
          lng: this.map_point.lon,
          draggable: true,
          icon: 'assets/img/marker.png'
        });
      }
    }
  }

  getPlots(farmId) {
    this.phameeService.getPlotDashboard(farmId)
      .subscribe(success => {
        if (success.code == 200) {
          this.AllPlot = success.data.plot.filter(plot=> plot._id == this.plot_id);

          if(this.AllPlot.length > 0){
            this.lat = this.AllPlot[0].center.center.lat;
            this.lng = this.AllPlot[0].center.center.lon;
            this.zoom = this.AllPlot[0].center.center.zoom_lv;
          }
  
          this.loadMap = true;
          this.spinner.hide();
  
        }else{
          this.AllPlot = [];
          
          this.loadMap = true;
          this.spinner.hide();
        }
      });
  }

  mapClicked($event: MouseEvent) {
    this.markers = [];
    this.markers.push({
      lat: $event['coords'].lat,
      lng: $event['coords'].lng,
      draggable: true,
      icon: 'assets/img/marker.png'
    });

    this.lat = parseFloat($event['coords'].lat.toFixed(6));
    this.lng = parseFloat($event['coords'].lng.toFixed(6));
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);

    this.lat = parseFloat($event['coords'].lat.toFixed(6));
    this.lng = parseFloat($event['coords'].lng.toFixed(6));
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      draggable: true
    });

    for (let i = 0; i < this.AllPlot.length; i++) {
      let polygons = [];
      const element = this.AllPlot[i];
      if(element.coordinates.map_polygon.length > 0){
        for (let j = 0; j < element.coordinates.map_polygon.length; j++) {
          const elementPolygon = element.coordinates.map_polygon[j];

          polygons.push(
            new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
          )
        }
      }
        
      this.polygons.push(
        { polygons: polygons, color: element.zone.color || 'red' }
      )
    }

    this.loadPolygon = true;
    this.reset();
  }

  reset(){
    this.cd.detectChanges();
  }

  save(){
    this.done.emit(
      {
        lat: this.lat,
        lng: this.lng
      }
    );
    this.closeModal.nativeElement.click();
  }

  close(){
    this.AllPlot = [];
    this.done.emit(false);
    this.reset();
  }
}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
  icon?: string;
}
